// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const LeavePlanDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-leaveplandialogcontainer" */ "./LeavePlanDialogContainer")).then((bundle)=>{
        return {
            default: bundle.LeavePlanDialogContainer
        };
    });
export const LazyLeavePlanDialogContainer = /*#__PURE__*/ lazy(LeavePlanDialogContainerLazyLoader);
